<template>
  <div id="management">
    <div class="header">
      <div class="left">
        <button @click="search">搜索</button>
        <input
          type="text"
          v-model="text"
          @keyup.enter="search"
          placeholder="关键词搜索"
          maxlength="18"
        />
      </div>
      <button @click="deriveChange(0)">全部数据导出</button>
    </div>
    <!-- 表格 -->
    <div class="main">
      <el-table
        ref="multipleTable"
        :data="tableDatas"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="formChange"
        :header-cell-style="{
          color: '#5F5F62',
          textAlign: 'center',
          fontSize: '18px',
        }"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="100px" align="center">
        </el-table-column>
        <el-table-column prop="XM" label="会员名称" align="center">
        </el-table-column>
        <el-table-column prop="CNAME" label="所属专委会" align="center"></el-table-column>
        <el-table-column prop="SFJDJGMC" label="所属单位" align="center">
        </el-table-column>
        <el-table-column prop="VIPZW" label="会员职务" align="center">
        </el-table-column>
        <el-table-column prop="ZY" label="专业" align="center">
        </el-table-column>
        <el-table-column label="入会时间" align="center">
          <template slot-scope="scope">{{ scope.row.SJCJSJ }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tail">
      <button @click="deriveChange(1)">数据导出</button>
      <pagination
        :totalPage="totalPage"
        @sizeChange="sizeChange"
        @currentChange="currentChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import pagination from "../../common/pagination";
import { pagingData, getRecordExport } from "../../../api/backstage";
export default {
  components: {
    pagination,
  },
  props: ["tabIndex"],
  data() {
    return {
      text: "",
      totalPage: 0, // 总条数 共X条
      showCount: 10, // 总记录数容量   如:15条/页
      currentPage: 1, // 当前页
      multipleSelection: [],
      tableDatas: [],
      ids: "",
    };
  },
  created() {
    this.tableDatas = this.tableData;
    this.getList();
  },
  methods: {
    // 搜索确认事件
    search() {
      pagingData({
        index: this.tabIndex,
        showCount: this.showCount,
        currentPage: this.currentPage,
        keywords: this.text,
      }).then((res) => {
        if (res.code == 1) {
          this.tableDatas = res.list;
          this.totalPage = res.totalResult;
        } else if (res.code == 1001) {
          this.$alert("请先登录", "警告", {
            confirmButtonText: "确定",
            type: "warning",
            callback: () => {
              this.$router.push("/login");
            },
          });
        } else if (res.code == -1) {
          this.$message.error("数据异常");
        }
      });
    },
    // 选中的表格内容
    formChange(val) {
      var arr = [];
      this.multipleSelection = val;
      this.multipleSelection.forEach((item) => {
        arr.push(item.AID);
      });
      this.ids = arr.join(",");
    },
    // pageSize 改变时会触发
    sizeChange(val) {
      this.showCount = val;
      this.currentPage = 1;
      if (this.text) {
        this.search();
      } else {
        this.getList();
      }
    },
    // currentPage 改变时会触发
    currentChange(val) {
      this.currentPage = val;
      if (this.text) {
        this.search();
      } else {
        this.getList();
      }
    },
    getList() {
      pagingData({
        index: this.tabIndex,
        showCount: this.showCount,
        currentPage: this.currentPage,
      }).then((res) => {
        if (res.code == 1) {
          this.tableDatas = res.list;
          this.totalPage = res.totalResult;
        } else {
          this.$alert("请先登录", "警告", {
            confirmButtonText: "确定",
            type: "warning",
            callback: () => {
              this.$router.push("/login");
            },
          });
        }
      });
    },
    deriveChange(index) {
      if (index == 0) {
        getRecordExport("/index/exportMPagelist", { index })
      } else {
        getRecordExport("/index/exportMPagelist", {
          index,
          ids: this.ids,
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.header {
  display: flex;
  justify-content: space-between;
  margin: 33px 40px 0 39px;
  .left {
    // display: flex;
    button {
      width: 96px;
      height: 40px;
      background: #e9ebed;
      border-radius: 10px;
      margin-right: 20px;
      font-size: 18px;
      color: #2d2d30;
      cursor: pointer;
    }
    input {
      width: 413px;
      height: 40px;
      background: url("../../../assets/htImg/icon_sousuo.png") no-repeat;
      background-position: 376px;
      border: 1px solid #cccccc;
      font-size: 18px;
      color: #a0a0a6;
      text-indent: 1em;
      padding-right: 60px;
    }
  }
  button {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: #b82925;
    border-radius: 20px;
    font-size: 18px;
    color: #ffffff;
  }
}
.main {
  margin: 35px 40px 20px 39px;
}
.tail {
  display: flex;
  justify-content: space-between;
  margin: 30px 40px 30px 30px;
  button {
    width: 111px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #585858;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    cursor: pointer;
    margin-left: 10px;
  }
}
</style>
